import React from "react";
import {connect} from "react-redux";
import LookCompatabilitySection from "../../lookNavigation/lookMain/lookCompatability/lookCompatabilitySection";

const GroheCompatabilitySection = (props) => {

  const {lookCompatabilityAlert} = props;

  return (
    <section className={"grohe-section grohe-section--compatability" + (lookCompatabilityAlert.visible ? " grohe-section--opened" : "")}>
      <LookCompatabilitySection wrapperStyles={{}}/>
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookCompatabilityAlert} = store.lookState;
  return {
    lookCompatabilityAlert
  };
};

export default connect(mapStateToProps, null)(GroheCompatabilitySection)
